<template>
  <div>
    <el-menu class="navbar" mode="horizontal">
      <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
      <breadcrumb></breadcrumb>
      <span class="shop-name">{{ shopName }}</span>
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <img class="user-avatar" :src="avatar">{{ userName }}
          <i class="el-icon-caret-bottom"></i>
        </div>
        <el-dropdown-menu class="user-dropdown" slot="dropdown">
          <router-link class="inlineBlock" to="/">
            <el-dropdown-item>
              首页
            </el-dropdown-item>
          </router-link>
          <el-dropdown-item>
            <span @click="showPsd = true">修改密码</span>
          </el-dropdown-item>
          <el-dropdown-item divided>
            <span @click="logout" style="display:block;">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-menu>


    <!-- <el-drawer title="我是标题" :visible.sync="showPsd" :with-header="false">
      <span>我来啦!</span>
    </el-drawer> -->
    <el-dialog
      title="修改密码"
      :visible.sync="showPsd"
      width="30%"
      :before-close="handleClose">
      <el-form :model="form"  :rules="rules" ref="form">      
        <el-form-item label="旧密码" label-width="80px" prop="oldPassword">
          <el-input v-model="form.oldPassword" autocomplete="off"></el-input>
        </el-form-item>   
        <el-form-item label="新密码" label-width="80px" prop="newPassword">
          <el-input v-model="form.newPassword" autocomplete="off"></el-input>
        </el-form-item>        
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showPsd = false">取 消</el-button>
        <el-button type="primary" :disabled="issub" @click="onChangePsd">确 定</el-button>
      </span>
    </el-dialog>
  </div> 
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import { getShopCurrentInfo } from '@/api/shop'
import { changePsd } from '@/api/login'

export default {
  components: {
    Breadcrumb,
    Hamburger
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar'
    ])
  },
  data() {
    return {
      //店铺名称
      shopName: '',
      // 当前用户名称
      userName: '',
      // 当前用户昵称
      nickName: '',

      showPsd: false,
      issub: false,
      form: {
        username: '',
        oldPassword: '',
        newPassword: ''
      },

      rules: {
        oldPassword: [{
          required: true, message: '请输入旧密码', trigger: 'blur' 
        }],
        newPassword: [{
          required: true, message: '请输入新密码', trigger: 'blur' 
        }],
      }
    }
  },
  created() {
    this.getShopInfo();
  },
  methods: {
    handleClose() {
      this.form.oldPassword = ''
      this.form.newPassword = ''
    },
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    onChangePsd() {
      this.$refs.form.validate(val => {
        if(val) {
          this.issub = true
          this.form.username = this.userName
          changePsd(this.form).then(res => {
            this.issub = false
            if(res.code == 200) {
              this.showPsd = false
            }
          })
        }
      })
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    },
    getShopInfo() {
      getShopCurrentInfo().then(response => {
        const model = response.data;
        this.shopName = model.shopName;
        this.userName = model.currentUserName;
        this.nickName = model.currentNickName;
        this.$store.commit('SET_SHOPID', model.id);
      });
    },
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  position: relative;

  .shop-name {
    position: absolute;
    left: 200px;
    top: 0;
    bottom: 0;
    right: 200px;
    text-align: center;
    font-size: 14px;
    z-index: 0;
  }

  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }

  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }

  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;

    .avatar-wrapper {
      cursor: pointer;
      margin-top: 5px;
      position: relative;

      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
        vertical-align: middle;
      }

      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue